import type { ManifoldAxes } from "@/lib/manifold/axes";

export type ManifoldPresetId = "pnl" | "decay" | "greeks" | "iv_shock";

export interface ManifoldPreset {
  id: ManifoldPresetId;
  axes: ManifoldAxes;
}

export const MANIFOLD_PRESETS: readonly ManifoldPreset[] = [
  {
    id: "pnl",
    axes: { x: "price", y: "dte", z: "pnl", colorBy: "pnl" },
  },
  {
    id: "decay",
    axes: { x: "price", y: "dte", z: "theta", colorBy: "pnl" },
  },
  {
    id: "greeks",
    axes: { x: "price", y: "dte", z: "gamma", colorBy: "delta" },
  },
  {
    id: "iv_shock",
    axes: { x: "price", y: "iv", z: "pnl", colorBy: "vega" },
  },
];

export const DEFAULT_MANIFOLD_AXES: ManifoldAxes = {
  ...MANIFOLD_PRESETS[0].axes,
};

export function manifoldPresetForAxes(
  axes: ManifoldAxes,
): ManifoldPresetId | null {
  return (
    MANIFOLD_PRESETS.find(
      (preset) =>
        preset.axes.x === axes.x &&
        preset.axes.y === axes.y &&
        preset.axes.z === axes.z &&
        preset.axes.colorBy === axes.colorBy,
    )?.id ?? null
  );
}
